import { get } from "../../../utils/objectHelpers";
import TextualDisplayValue from "<str-textual-display>";
import ImageSquare from "<str-image-square>";
import IconAndText from "<str-icon-text>";
import TimerModel from "<str-timer>";
import EekTire from "<str-eek-tire>";
import Signal from "<str-signal>";
import Icon from "<str-icon>";
static const componentMapping = {
    additionalPrice: TextualDisplayValue,
    authenticityGuarantee: IconAndText,
    logisticsCost: TextualDisplayValue,
    displayPrice: TextualDisplayValue,
    displayTime: TextualDisplayValue,
    eekrating: TextualDisplayValue,
    unitPrice: TextualDisplayValue,
    discount: TextualDisplayValue,
    bidCount: TextualDisplayValue,
    quantity: TextualDisplayValue,
    title: TextualDisplayValue,
    itemHotness: IconAndText,
    image: ImageSquare,
    eekTire: EekTire,
    timer: TimerModel,
    "__search.itemHotnessCustomizedOrder": IconAndText,
    "__search.nonMskuAdditionalPrice": TextualDisplayValue,
    "__search.freeReturnsNoFee": TextualDisplayValue,
    "__search.timer": TimerModel,
    __signal: Signal
}

<if(input.properties && input.properties[input.sectionName])>
    <div class=`str-item-card__${input.sectionName}`>
        <for|position, positionIdx| of=input.properties[input.sectionName]>
            $ const blockTag = position.length > 1 ? "span" : null;
            <${blockTag} class="str-item-card__property-block">
                <for|property, idx| of=position>
                    $ {
                        const propertyItem = get(input.card, property, {});
                        if (property === "image" && input.card._type !== "NavigationCard") {
                            propertyItem.noScaling = true;
                        }
                    }
                    <if(propertyItem && componentMapping[property])>
                        <${componentMapping[property]}
                            key=idx
                            class=`str-item-card__property-${property}`
                            imageSize=input.imageSize
                            isSmall=input.isSmall
                            ...propertyItem
                        />
                    </if>
                </for>
            </>
        </for>
    </div>
</if>
